import React, { useEffect, useState, useContext } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import '../styles/Home.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AuthContext } from '../context/AuthContext';
import { apiService, setupInterceptors } from '../services/apiService';

import ModalContainer from './ModalContainer';
import HeaderComponent from './HeaderComponent';
import FormNuevoProveedor from './FormNuevoProveedor';
import FormNuevoMetodoPago from './FormNuevoMetodoPago';

const Configuraciones = ({ toast }) => {
    const { logoutUser } = useContext(AuthContext);

    const [ proveedores, setProveedores ] = useState([])
    const [showModalProveedor, setShowModalProveedor] = useState(false);

    const [ metodosPago, setMetodosPago ] = useState([])
    const [showModalMetodosPago, setShowModalMetodosPago] = useState(false);


    const openModalProveedor = () => setShowModalProveedor(true);
    const hideModalProveedor = () => setShowModalProveedor(false);

    const openModalMetodosPago = () => setShowModalMetodosPago(true);
    const hideModalMetodosPago = () => setShowModalMetodosPago(false);


    useEffect(() => {
        // Configura el interceptor con la función de logout
        setupInterceptors(logoutUser);
        getProveedores();
        getMetodosPago();
    }, [logoutUser]);

    const getProveedores = async () => {
        try {
            const response = await apiService.fetchData('proveedores/');
            const proveedoresList = response.data.map(proveedor => ({
                id: proveedor.id,
                nombre: proveedor.nombre,
                contacto: proveedor.contacto
            }));
            setProveedores(proveedoresList); 
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };


    const postProveedor = async (data) => {
        try {
            const response = await apiService.postData('proveedores/', data);
            const nuevoProveedor = {
                id: response.data.id,
                nombre: response.data.nombre,
                contacto: response.data.contacto
            };
            
            // Actualiza el estado de las categorías agregando la nueva categoría
            setProveedores(prevProveedores => [...prevProveedores, nuevoProveedor]);

            toast.current.show({severity:'success', summary: 'Solicitud Exitosa', detail:'Producto creado exitosamente!', life: 2000});

            
            // Opcional: cierra el modal tras agregar la nueva categoría
            hideModalProveedor();

        } catch (error) {
            toast.current.show({severity:'error', summary: 'Error', detail:{error}, life: 3000});
            console.error('Error al realizar la creacion:', error.response ? error.response.data : error.message);
        }
    };

    const getMetodosPago = async () => {
        try {
            const response = await apiService.fetchData('metodos_pago/');
            const metodosPagoList = response.data.map(metodo_pago => ({
                id: metodo_pago.id,
                nombre: metodo_pago.nombre,
                interes: metodo_pago.interes
            }));
            setMetodosPago(metodosPagoList); 
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };

    const postMetodoPago = async (data) => {
        try {
            const response = await apiService.postData('metodos_pago/', data);
            const nuevoMetodoPago = {
                id: response.data.id,
                nombre: response.data.nombre,
                interes: response.data.interes
            };
            
            // Actualiza el estado de las categorías agregando la nueva categoría
            setMetodosPago(prevMetodosPago => [...prevMetodosPago, nuevoMetodoPago]);

            toast.current.show({severity:'success', summary: 'Solicitud Exitosa', detail:'Producto creado exitosamente!', life: 2000});

            
            // Opcional: cierra el modal tras agregar la nueva categoría
            hideModalMetodosPago();

        } catch (error) {
            toast.current.show({severity:'error', summary: 'Error', detail:{error}, life: 3000});
            console.error('Error al realizar la creacion:', error.response ? error.response.data : error.message);
        }
    };


    return (
        <>
            <HeaderComponent title={"Configuraciones"} />
            <div className='col-12 ml-6' style={{ minWidth:"95%", maxWidth:"95%" }}>
                <div className='ml-2' style={{ fontSize:"20px" }}>
                    <p>
                        Bienvenid@ al Configuraciones
                    </p>
                </div>
                
                {/* Accordion Section */}
                <div className="card mt-4">
                    <Accordion>
                        <AccordionTab header="Proveedores">
                            <Button  label='Crear Proveedor' size='small' severity='warning'
                            onClick={() => openModalProveedor(true)}
                            />
                            <div className='mt-3'>
                                <DataTable value={proveedores}>
                                    <Column field="id" header="Id" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                                    <Column field="nombre" header="Nombre" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                                    <Column field="contacto" header="Contacto" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                                    <Column field="acciones" header="Acciones" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                                </DataTable>
                            </div>
                        </AccordionTab>
                        <AccordionTab header="Metodos de Pago">
                            <Button  label='Crear Metodo de Pago' size='small' severity='warning'
                            onClick={() => openModalMetodosPago(true)}
                            />
                            <div className='mt-3'>
                                <DataTable value={metodosPago}>
                                    <Column field="id" header="Id" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                                    <Column field="nombre" header="Nombre" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                                    <Column field="interes" header="Intereses (en %)" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                                    <Column field="acciones" header="Acciones" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                                </DataTable>
                            </div>
                        </AccordionTab>
                    </Accordion>
                </div>
            </div>

            <ModalContainer
                title="Agregar Proveedor"
                show={showModalProveedor}
                close={hideModalProveedor}
                idForm="FormNuevoProveedor"
                widthSize="25vw">
                <FormNuevoProveedor postProveedor={postProveedor} />
            </ModalContainer>

            <ModalContainer
                title="Agregar Metodo de Pago"
                show={showModalMetodosPago}
                close={hideModalMetodosPago}
                idForm="FormNuevoMetodoPago"
                widthSize="25vw">
                <FormNuevoMetodoPago postMetodoPago={postMetodoPago} />
            </ModalContainer>
        </>
    );
};

export default Configuraciones;
